import { useState, useEffect } from 'react';

import { storage } from "@/utils/storageManager";
import { AppSettings } from "@/utils/storageManager";
import authBg from "@/assets/auth_bg.png";

interface BackgroundWavesProps {
  isDarkMode: boolean;
  className?: string;
}

export const BackgroundWaves = ({ isDarkMode, className = '' }: BackgroundWavesProps) => {
  const [backgroundType, setBackgroundType] = useState<'solid' | 'image'>('solid');

  /*
    const [backgroundType, setBackgroundType] = useState<'solid' | 'image'>(() => {
      try {
        const settings = storage.getAppSettings() as AppSettings;
        const bt = (settings?.backgroundType as 'solid' | 'image' | undefined) ?? 'solid';
        return bt === 'image' ? 'image' : 'solid';
      } catch (error) {
        console.error('Error loading background setting:', error);
        return 'solid';
      }
    });
  
    // Listen for app settings changes
    useEffect(() => {
      const handleAppSettingsChange = (e: CustomEvent) => {
        const nextType = e.detail?.backgroundType;
        if (nextType === 'solid' || nextType === 'image') {
          setBackgroundType(nextType);
        } else {
          setBackgroundType('solid');
        }
      };
  
      window.addEventListener('appSettingsChanged', handleAppSettingsChange as EventListener);
      return () => {
        window.removeEventListener('appSettingsChanged', handleAppSettingsChange as EventListener);
      };
    }, []);
  */

  // Render based on background type
  if (true) { // Force solid
    return (
      <div
        className={`fixed inset-0 ${isDarkMode ? 'bg-[#303030]' : 'bg-white'} ${className} transition-all duration-1000 ease-in-out`}
        style={{
          zIndex: 0,
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          pointerEvents: 'none',
          opacity: 1,
        }}
      />
    );
  }

  /*
  if (backgroundType === 'image') {
    return (
      <div
        className={`fixed inset-0 ${className}`}
        style={{
          zIndex: 0,
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundImage: `url(${authBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          pointerEvents: 'none',
          opacity: 1,
          transition: 'opacity 1s cubic-bezier(0.4, 0, 0.2, 1)'
        }}
      >
        <div className={`absolute inset-0 pointer-events-none transition-colors duration-300`} />
      </div>
    );
  }
  */


  return null;
};
